<template>
    <div>
        <!-- 1. Grace Period & Denda per Tipe Pinjaman -->
        <b-form @submit.prevent="openModalConfirmDenda">
            <div class="mb-4" style="max-width: 480px;">
                <label class="param-grid-label">
                    GRACE PERIOD <i class="fa fa-info-circle text-muted ml-1" id="tip-grace"></i>
                    <b-popover target="tip-grace" triggers="hover focus" placement="top">
                        Tambahan hari toleransi keterlambatan pembayaran sebelum dikenakan denda.
                    </b-popover>
                </label>
                <b-input-group append="hari" class="input-group-custom">
                    <b-form-input v-model="dendaPenaltiInput.GRACE_PERIOD" type="number" class="form-control-custom" required></b-form-input>
                </b-input-group>
            </div>

            <div class="parameter-section-card mb-4">
                <h6 class="parameter-card-title">Denda per Tipe Pinjaman</h6>
                <p class="parameter-card-subtitle">Persentase denda harian setelah grace period. Baris mengikuti master Tipe Pinjaman yang aktif.</p>

                <div class="table-responsive">
                    <table class="table parameter-matrix-table mb-0">
                        <thead>
                            <tr>
                                <th style="width: 50%;">TIPE PINJAMAN</th>
                                <th style="width: 50%;">DENDA HARIAN</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="localJenisPinjamanList.length === 0">
                                <td colspan="2" class="text-center py-3 text-muted">Memuat data tipe pinjaman...</td>
                            </tr>
                            <tr v-for="(item, idx) in localJenisPinjamanList" :key="idx">
                                <td class="align-middle">
                                    <div class="font-weight-bold text-dark">{{ item.jenisPinjamanName }}</div>
                                    <span class="badge-kode-subtle" v-if="item.jenisPinjamanKode">{{ item.jenisPinjamanKode }}</span>
                                </td>
                                <td class="align-middle">
                                    <b-input-group append="%" class="input-group-custom" style="max-width: 260px;">
                                        <b-form-input v-model="item.dendaHarianPersen" type="number" step="0.01" class="form-control-custom text-right" required></b-form-input>
                                    </b-input-group>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div class="d-flex justify-content-end mt-4">
                    <button type="submit" class="btn btn-save-primary" :disabled="isSubmittingDenda">
                        <b-spinner small v-if="isSubmittingDenda" class="mr-1"></b-spinner>
                        {{ isSubmittingDenda ? 'Menyimpan...' : 'Simpan' }}
                    </button>
                </div>
            </div>
        </b-form>

        <!-- 2. Penalti per Jenis Barang (CRUD Override) -->
        <div class="parameter-section-card">
            <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                <div>
                    <h6 class="parameter-card-title mb-1">Penalti per Jenis Barang</h6>
                    <p class="parameter-card-subtitle mb-0">Penalti dikenakan setelah jumlah bulan keterlambatan tercapai. Hanya jenis barang yang ditambahkan di sini yang dikenai penalti.</p>
                </div>
                <button type="button" class="btn btn-tambah-primary" @click="openModalTambahPenalti">
                    <i class="fa fa-plus mr-1"></i> Tambah Penalti
                </button>
            </div>

            <div class="table-responsive">
                <table class="table custom-table-override mb-0">
                    <thead>
                        <tr>
                            <th style="width: 25%;">TIPE PINJAMAN</th>
                            <th style="width: 30%;">JENIS BARANG</th>
                            <th style="width: 20%;" class="text-right">NOMINAL PENALTI</th>
                            <th style="width: 15%;" class="text-right">KETERLAMBATAN</th>
                            <th style="width: 10%;" class="text-center">AKSI</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="barangJenisListFiltered.length === 0">
                            <td colspan="5" class="text-center py-4 text-muted">Belum ada penalti khusus jenis barang.</td>
                        </tr>
                        <tr v-for="(item, idx) in barangJenisListFiltered" :key="idx">
                            <td class="align-middle text-muted">{{ getTipePinjamanName(item) }}</td>
                            <td class="align-middle font-weight-600 text-dark">{{ item.barangJenisName }}</td>
                            <td class="align-middle text-right font-weight-600 text-dark">{{ item.penaltiNominal ? 'Rp. ' + $helper.addThousandSeparator(item.penaltiNominal) : '-' }}</td>
                            <td class="align-middle text-right font-weight-600 text-dark">{{ item.penaltiJumlahBulanKeterlambatan ? item.penaltiJumlahBulanKeterlambatan + ' bulan' : '-' }}</td>
                            <td class="align-middle text-center">
                                <span class="action-link text-primary mr-2" @click="editBarangJenis(item)">Ubah</span>
                                <span class="action-link text-danger" @click="confirmDeleteBarangJenis(item)">Hapus</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <!-- Modal Tambah / Edit Penalti Khusus -->
        <b-modal 
            id="modal-barang-penalti" 
            centered 
            hide-header 
            hide-footer
            body-class="p-0"
            content-class="modal-custom-card"
        >
            <div class="modal-body-wrapper p-4">
                <!-- Modal Header -->
                <div class="d-flex align-items-start justify-content-between mb-3">
                    <div>
                        <h5 class="modal-custom-title mb-1">
                            {{ isEditingModal ? 'Ubah Penalti Jenis Barang' : 'Tambah Penalti Jenis Barang' }}
                        </h5>
                        <p class="modal-custom-subtitle mb-0">
                            Penalti ini dikenakan pada keterlambatan pembayaran untuk jenis barang terpilih.
                        </p>
                    </div>
                    <button type="button" class="btn-modal-close" @click="$bvModal.hide('modal-barang-penalti')">
                        <i class="fa fa-times"></i>
                    </button>
                </div>

                <b-form @submit.prevent="submitModalBarangPenalti">
                    <!-- TIPE PINJAMAN -->
                    <div class="form-group-custom mb-3">
                        <label class="modal-field-label">TIPE PINJAMAN <span class="text-danger">*</span></label>
                        <div class="chips-container d-flex flex-wrap">
                            <button
                                type="button"
                                v-for="tp in optTipePinjaman"
                                :key="tp.id"
                                class="btn-chip mr-2 mb-2"
                                :class="{ 'active': modalForm.tipePinjamanId === tp.id }"
                                :disabled="isEditingModal"
                                @click="selectTipePinjaman(tp.id)"
                            >
                                {{ tp.name }}
                            </button>
                        </div>
                    </div>

                    <!-- JENIS BARANG -->
                    <div class="form-group-custom mb-3">
                        <label class="modal-field-label mb-1">JENIS BARANG <span class="text-danger">*</span></label>
                        <div class="modal-field-helper mb-2">Pilih tipe pinjaman dulu untuk melihat jenis barangnya.</div>
                        <div class="chips-container d-flex flex-wrap">
                            <div v-if="optBarangJenisFiltered.length === 0" class="text-muted small py-1">
                                {{ modalForm.tipePinjamanId ? 'Tidak ada jenis barang pada tipe pinjaman ini.' : 'Belum ada tipe pinjaman yang dipilih.' }}
                            </div>
                            <button
                                type="button"
                                v-for="bj in optBarangJenisFiltered"
                                :key="bj.id"
                                class="btn-chip mr-2 mb-2"
                                :class="{ 'active': modalForm.barangJenisId === bj.id }"
                                :disabled="isEditingModal"
                                @click="selectBarangJenis(bj)"
                            >
                                {{ bj.name }}
                            </button>
                        </div>
                    </div>

                    <!-- NOMINAL PENALTI & KETERLAMBATAN -->
                    <div class="row mb-3">
                        <div class="col-6">
                            <label class="modal-field-label">NOMINAL PENALTI <span class="text-danger">*</span></label>
                            <b-input-group prepend="Rp." class="input-group-custom">
                                <b-form-input 
                                    v-model="modalForm.penaltiNominalFormatted" 
                                    @input="formatModalNominal" 
                                    placeholder="0" 
                                    class="form-control-custom" 
                                    required
                                ></b-form-input>
                            </b-input-group>
                        </div>
                        <div class="col-6">
                            <label class="modal-field-label">BULAN KETERLAMBATAN <span class="text-danger">*</span></label>
                            <b-input-group append="bulan" class="input-group-custom">
                                <b-form-input 
                                    v-model="modalForm.penaltiJumlahBulanKeterlambatan" 
                                    type="number" 
                                    placeholder="1" 
                                    class="form-control-custom" 
                                    required
                                ></b-form-input>
                            </b-input-group>
                        </div>
                    </div>

                    <!-- MODAL FOOTER BUTTONS -->
                    <div class="d-flex justify-content-end align-items-center mt-4 pt-2">
                        <button type="button" class="btn btn-modal-cancel mr-2" @click="$bvModal.hide('modal-barang-penalti')">
                            Batal
                        </button>
                        <button 
                            type="submit" 
                            class="btn btn-modal-submit" 
                            :disabled="!modalForm.tipePinjamanId || !modalForm.barangJenisId || isSubmittingModal"
                        >
                            <b-spinner small v-if="isSubmittingModal" class="mr-1"></b-spinner>
                            {{ isEditingModal ? 'Simpan' : 'Tambah' }}
                        </button>
                    </div>
                </b-form>
            </div>
        </b-modal>

        <!-- Modal Confirm Simpan Denda -->
        <ModalConfirm 
            id="modal-confirm-denda" 
            title="Konfirmasi Perubahan Denda & Grace Period" 
            :isSubmitting="isSubmittingDenda" 
            desc="Apakah anda yakin ingin menyimpan perubahan parameter denda ini?" 
            @submit="onSubmitDenda" 
        />

        <!-- Modal Confirm Hapus Penalti Khusus -->
        <ModalConfirm 
            id="modal-confirm-delete-bjp-penalti" 
            title="Konfirmasi Hapus Penalti Khusus" 
            :isSubmitting="isSubmittingDelete" 
            desc="Apakah anda yakin ingin menghapus tarif penalti khusus untuk jenis barang ini?" 
            @submit="submitDeleteBarangJenis" 
        />
    </div>
</template>

<script>
export default {
    name: 'denda-penalti',
    props: {
        dendaPenaltiInput: { type: Object, default: () => ({}) },
        jenisPinjamanList: { type: Array, default: () => [] },
        barangJenisList: { type: Array, default: () => [] },
        wilayahId: { type: [Number, String], default: null }
    },
    data() {
        return {
            isSubmittingDenda: false,
            isSubmittingModal: false,
            isSubmittingDelete: false,
            isEditingModal: false,
            localJenisPinjamanList: [],
            allBarangJenis: [],
            selectedDeleteItem: null,
            modalForm: {
                tipePinjamanId: null,
                barangJenisId: null,
                penaltiNominal: null,
                penaltiNominalFormatted: '',
                penaltiJumlahBulanKeterlambatan: null
            }
        }
    },
    computed: {
        barangJenisListFiltered() {
            return (this.barangJenisList || []).filter(item => item.penaltiNominal !== null || item.penaltiJumlahBulanKeterlambatan !== null)
        },
        optTipePinjaman() {
            return this.localJenisPinjamanList.map(item => ({
                id: item.jenisPinjamanId,
                name: item.jenisPinjamanName
            }))
        },
        optBarangJenisFiltered() {
            if (!this.modalForm.tipePinjamanId) return this.allBarangJenis
            return this.allBarangJenis.filter(b => b.jenisPinjamanId === this.modalForm.tipePinjamanId || b.tipePinjamanId === this.modalForm.tipePinjamanId)
        }
    },
    watch: {
        jenisPinjamanList: {
            handler(newVal) {
                this.localJenisPinjamanList = JSON.parse(JSON.stringify(newVal || []))
            },
            immediate: true,
            deep: true
        }
    },
    methods: {
        formatModalNominal(val) {
            const num = String(val).replace(/\D/g, "")
            this.modalForm.penaltiNominal = num ? parseInt(num) : 0
            this.modalForm.penaltiNominalFormatted = this.$helper.addThousandSeparator(this.modalForm.penaltiNominal)
        },

        getTipePinjamanName(item) {
            if (typeof item === 'object' && item !== null) {
                if (item.jenisPinjamanName) return item.jenisPinjamanName
                const found = this.localJenisPinjamanList.find(t => t.jenisPinjamanId === item.jenisPinjamanId)
                return found ? found.jenisPinjamanName : '-'
            }
            const found = this.localJenisPinjamanList.find(t => t.jenisPinjamanId === item)
            return found ? found.jenisPinjamanName : '-'
        },

        openModalConfirmDenda() {
            this.$bvModal.show("modal-confirm-denda")
        },

        async onSubmitDenda() {
            this.isSubmittingDenda = true
            try {
                // 1. Update Denda Per-Jenis Pinjaman
                if (this.wilayahId && this.localJenisPinjamanList.length > 0) {
                    for (let item of this.localJenisPinjamanList) {
                        let payload = new FormData()
                        payload.append("wilayahId", this.wilayahId)
                        payload.append("jenisPinjamanId", item.jenisPinjamanId)
                        payload.append("bungaTenor1", item.bungaTenor1 || 0)
                        payload.append("bungaTenor2", item.bungaTenor2 || 0)
                        payload.append("admAwalPersen", item.admAwalPersen || 0)
                        payload.append("admAwalNominalMin", item.admAwalNominalMin || 0)
                        payload.append("admBulananPersen", item.admBulananPersen || 0)
                        payload.append("admBulananNominalMin", item.admBulananNominalMin || 0)
                        payload.append("dendaHarianPersen", item.dendaHarianPersen || 0)
                        payload.append("maxGadaiNominal", item.maxGadaiNominal || 0)

                        await this.$axios.post("parameter/update-jenis-pinjaman", payload)
                    }
                }

                // 2. Update Global Grace Period
                let globalPayload = new FormData()
                globalPayload.append("name", "GRACE_PERIOD")
                globalPayload.append("value", this.dendaPenaltiInput.GRACE_PERIOD || 1)
                await this.$axios.post("parameter/update", globalPayload)

                this.$helper.toastSucc(this, "Parameter Denda & Grace Period berhasil disimpan!")
                this.$bvModal.hide("modal-confirm-denda")
                this.$emit("refresh")
            } catch (err) {
                this.$helper.parseError(this, err)
            } finally {
                this.isSubmittingDenda = false
            }
        },

        async loadAllBarangJenis() {
            try {
                const res = await this.$axios.get("barang-jenis/")
                let list = Array.isArray(res.data) ? res.data : (res.data && Array.isArray(res.data.data) ? res.data.data : [])
                this.allBarangJenis = list.map(item => ({
                    id: item.id || item.jenisBarangId,
                    name: item.name || item.jenisBarangName,
                    jenisPinjamanId: (item.jenisPinjaman && item.jenisPinjaman.id) ? item.jenisPinjaman.id : (item.tipePinjamanId || item.jenisPinjamanId)
                }))
            } catch (e) {
                console.warn("Gagal load all barang jenis dari barang-jenis/, mencoba barang-jenis-atribut/:", e)
                try {
                    const res2 = await this.$axios.get("barang-jenis-atribut/")
                    let list2 = Array.isArray(res2.data) ? res2.data : (res2.data && Array.isArray(res2.data.data) ? res2.data.data : [])
                    this.allBarangJenis = list2.map(item => ({
                        id: item.jenisBarangId || item.id,
                        name: item.jenisBarangName || item.name,
                        jenisPinjamanId: item.tipePinjamanId || (item.jenisPinjaman ? item.jenisPinjaman.id : null)
                    }))
                } catch (e2) {
                    console.error("Gagal load all barang jenis:", e2)
                }
            }
        },

        openModalTambahPenalti() {
            this.isEditingModal = false
            this.modalForm = {
                tipePinjamanId: null,
                barangJenisId: null,
                penaltiNominal: 0,
                penaltiNominalFormatted: '',
                penaltiJumlahBulanKeterlambatan: null
            }
            this.loadAllBarangJenis()
            this.$bvModal.show("modal-barang-penalti")
        },

        editBarangJenis(item) {
            this.isEditingModal = true
            this.modalForm = {
                tipePinjamanId: item.jenisPinjamanId,
                barangJenisId: item.barangJenisId,
                penaltiNominal: item.penaltiNominal || 0,
                penaltiNominalFormatted: this.$helper.addThousandSeparator(item.penaltiNominal || 0),
                penaltiJumlahBulanKeterlambatan: item.penaltiJumlahBulanKeterlambatan
            }
            this.loadAllBarangJenis()
            this.$bvModal.show("modal-barang-penalti")
        },

        onModalTipePinjamanChange() {
            this.modalForm.barangJenisId = null
        },

        selectTipePinjaman(id) {
            if (this.isEditingModal) return
            this.modalForm.tipePinjamanId = id
            this.modalForm.barangJenisId = null
        },

        selectBarangJenis(bj) {
            if (this.isEditingModal) return
            this.modalForm.barangJenisId = bj.id
            if (!this.modalForm.tipePinjamanId && bj.jenisPinjamanId) {
                this.modalForm.tipePinjamanId = bj.jenisPinjamanId
            }
        },

        async submitModalBarangPenalti() {
            if (!this.wilayahId || !this.modalForm.barangJenisId) return
            this.isSubmittingModal = true
            try {
                let payload = new FormData()
                payload.append("wilayahId", this.wilayahId)
                payload.append("barangJenisId", this.modalForm.barangJenisId)
                // Biaya admin jenis barang yang sama tidak tersentuh
                payload.append("bagian", "PENALTI")
                payload.append("penaltiNominal", this.modalForm.penaltiNominal || 0)
                payload.append("penaltiJumlahBulanKeterlambatan", this.modalForm.penaltiJumlahBulanKeterlambatan || 1)

                await this.$axios.post("parameter/update-barang-jenis", payload)
                this.$helper.toastSucc(this, "Penalti khusus jenis barang berhasil disimpan!")
                this.$bvModal.hide("modal-barang-penalti")
                this.$emit("refresh")
            } catch (err) {
                this.$helper.parseError(this, err)
            } finally {
                this.isSubmittingModal = false
            }
        },

        confirmDeleteBarangJenis(item) {
            this.selectedDeleteItem = item
            this.$bvModal.show("modal-confirm-delete-bjp-penalti")
        },

        async submitDeleteBarangJenis() {
            if (!this.selectedDeleteItem || !this.selectedDeleteItem.id) return
            this.isSubmittingDelete = true
            try {
                // Hanya mengosongkan penalti; biaya admin jenis barang yang sama tetap ada
                await this.$axios.delete(`parameter/barang-jenis/${this.selectedDeleteItem.id}?bagian=PENALTI`)
                this.$helper.toastSucc(this, "Penalti khusus berhasil dihapus!")
                this.$bvModal.hide("modal-confirm-delete-bjp-penalti")
                this.$emit("refresh")
            } catch (err) {
                this.$helper.parseError(this, err)
            } finally {
                this.isSubmittingDelete = false
            }
        }
    },
    created() {
        this.loadAllBarangJenis()
    }
}
</script>

<style lang="scss" scoped>
.parameter-section-card {
    background-color: #ffffff;
    border: 1px solid #e2ece7;
    border-radius: 10px;
    padding: 20px 24px;
}

.parameter-card-title {
    font-size: 14px;
    font-weight: 700;
    color: #0f172a;
    margin-bottom: 2px;
}

.parameter-card-subtitle {
    font-size: 12.5px;
    color: #64748b;
    margin-bottom: 16px;
}

.parameter-matrix-table {
    thead th {
        background-color: transparent;
        color: #64748b;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        border-top: none;
        border-bottom: 1px solid #e2ece7;
        padding: 10px 12px;
    }

    tbody td {
        padding: 12px;
        border-top: 1px solid #edf4f1;
        border-bottom: none;
    }
}

.custom-table-override {
    thead th {
        background-color: #fafcfb;
        color: #64748b;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.6px;
        text-transform: uppercase;
        border-top: none;
        border-bottom: 1px solid #e2ece7;
        padding: 12px 14px;
    }

    tbody td {
        padding: 14px;
        border-top: 1px solid #edf4f1;
        border-bottom: none;
        font-size: 13px;
    }
}

.badge-kode-subtle {
    font-size: 11px;
    color: #94a3b8;
    font-weight: 600;
    text-transform: uppercase;
}

.param-grid-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #475569;
    text-transform: uppercase;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
}

.form-control-custom {
    border-radius: 8px !important;
    border: 1px solid #d8e2dc !important;
    font-size: 13px !important;
    height: 38px !important;
    color: #1e293b !important;

    &:focus {
        border-color: #0b3b36 !important;
        box-shadow: 0 0 0 2px rgba(11, 59, 54, 0.12) !important;
    }
}

.input-group-custom {
    ::v-deep .input-group-text {
        background-color: #f8fafc;
        border-color: #d8e2dc;
        font-size: 12.5px;
        font-weight: 600;
        color: #64748b;
    }
}

.btn-save-primary {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 9px 32px;
    font-size: 13.5px;
    font-weight: 700;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        box-shadow: 0 2px 8px rgba(11, 59, 54, 0.2);
    }
}

.btn-tambah-primary {
    background-color: #0b3b36;
    color: #ffffff;
    border: 1px solid #0b3b36;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 13px;
    font-weight: 700;
    transition: all 0.2s ease;
    cursor: pointer;

    &:hover {
        background-color: #082d29;
        border-color: #082d29;
    }
}

.action-link {
    cursor: pointer;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.font-weight-600 {
    font-weight: 600;
}

/* Modal Custom Styling */
::v-deep .modal-custom-card {
    border-radius: 14px !important;
    border: none !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1) !important;
    overflow: hidden;

    .modal-content {
        border-radius: 14px !important;
        border: none !important;
    }
}

.modal-custom-title {
    font-size: 16px;
    font-weight: 700;
    color: #0b3b36;
    letter-spacing: -0.2px;
}

.modal-custom-subtitle {
    font-size: 12.5px;
    color: #64748b;
    line-height: 1.4;
}

.btn-modal-close {
    background: transparent;
    border: none;
    color: #94a3b8;
    font-size: 16px;
    padding: 4px;
    cursor: pointer;
    line-height: 1;
    transition: color 0.15s ease;

    &:hover {
        color: #0f172a;
    }
}

.modal-field-label {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.6px;
    color: #64748b;
    text-transform: uppercase;
    margin-bottom: 6px;
    display: block;
}

.modal-field-helper {
    font-size: 12px;
    color: #64748b;
}

.btn-chip {
    background-color: #ffffff;
    border: 1px solid #d8e2dc;
    border-radius: 8px;
    padding: 7px 18px;
    font-size: 13px;
    font-weight: 600;
    color: #334155;
    cursor: pointer;
    transition: all 0.15s ease;
    outline: none !important;

    &:hover:not(:disabled) {
        border-color: #0b3b36;
        color: #0b3b36;
        background-color: #f8fafc;
    }

    &.active {
        background-color: #0b3b36 !important;
        border-color: #0b3b36 !important;
        color: #ffffff !important;
        box-shadow: 0 2px 6px rgba(11, 59, 54, 0.2);
    }

    &:disabled {
        opacity: 0.65;
        cursor: not-allowed;
    }
}

.btn-modal-cancel {
    background: #ffffff;
    border: 1px solid #d8e2dc;
    color: #334155;
    border-radius: 8px;
    padding: 8px 24px;
    font-size: 13.5px;
    font-weight: 600;
    transition: all 0.15s ease;

    &:hover {
        background-color: #f1f5f9;
        color: #0f172a;
    }
}

.btn-modal-submit {
    background-color: #0b3b36;
    border: 1px solid #0b3b36;
    color: #ffffff;
    border-radius: 8px;
    padding: 8px 28px;
    font-size: 13.5px;
    font-weight: 700;
    transition: all 0.15s ease;

    &:hover:not(:disabled) {
        background-color: #082d29;
        border-color: #082d29;
        box-shadow: 0 2px 8px rgba(11, 59, 54, 0.2);
    }

    &:disabled {
        background-color: #9ab4aa !important;
        border-color: #9ab4aa !important;
        color: #ffffff !important;
        opacity: 0.85;
        cursor: not-allowed;
    }
}
</style>
